// Reconstructed from the supplied production build; original component names were unavailable.
import {
  Bi as ResponsiveContainer,
  CircleCheckBigIcon,
  DollarSignIcon,
  DownloadIcon,
  Io as CartesianGrid,
  Jn as Legend,
  MR as LineChart,
  Nn as Tooltip,
  PackageIcon,
  Ps as Cell,
  Qr as Pie,
  React,
  RefreshCwIcon,
  TrendingUpIcon,
  Xa as YAxis,
  Ya as XAxis,
  _l as Line,
  ai as Bar,
  jsxRuntime,
  l1 as PieChart,
  motion,
  o1 as BarChart,
  useNavigate,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const AnalyticsPage = () => {
  var Y, F, B, K, Q, ne, L, ee, re;
  const [e, t] = React.useState(null),
    [n, r] = React.useState(null),
    [a, l] = React.useState(true),
    [c, d] = React.useState(null),
    [f, h] = React.useState("overview"),
    [p, g] = React.useState(1),
    [y] = React.useState(10),
    v = useNavigate();
  React.useEffect(() => {
    j();
  }, []);
  const j = async () => {
      try {
        (l(true), d(null));
        const R = await api.get("/admin/analytics/products");
        (console.log("Product Analytics Response:", R.data), t(R.data));
        const W = await api.get("/admin/analytics/financial");
        (console.log("Financial Summary Response:", W.data), r(W.data));
      } catch (R) {
        (console.error("Error fetching analytics:", R),
          d("Failed to load analytics data. Please try again later."));
      } finally {
        l(false);
      }
    },
    N = (R) =>
      typeof R != "number" && typeof R != "string" ? "₹0.00" : `₹${parseFloat(R).toFixed(2)}`,
    b = () => {
      if (!(e != null && e.categoryCounts) || !Array.isArray(e.categoryCounts))
        return (
          console.log(
            "Category data not available or invalid:",
            e == null ? undefined : e.categoryCounts,
          ),
          []
        );
      const R = e.categoryCounts.filter((W) => W && W.category && (W.count || W.count === 0));
      return (console.log("Prepared category data:", R), R);
    },
    S = () => {
      if (!(e != null && e.analysisStatus) || !Array.isArray(e.analysisStatus))
        return (
          console.log(
            "Analysis status data not available or invalid:",
            e == null ? undefined : e.analysisStatus,
          ),
          []
        );
      const R = e.analysisStatus
        .filter((W) => W && (W.count || W.count === 0))
        .map((W) => ({
          ...W,
          status: W.analysis_status || "Not Analyzed",
          name: W.analysis_status || "Not Analyzed",
        }));
      return (console.log("Prepared analysis status data:", R), R);
    },
    O = () => {
      if (!(e != null && e.topProducts) || !Array.isArray(e.topProducts)) return [];
      const R = (p - 1) * y,
        W = R + y;
      return e.topProducts.slice(R, W);
    },
    _ = () =>
      !(e != null && e.topProducts) || !Array.isArray(e.topProducts)
        ? 0
        : Math.ceil(e.topProducts.length / y),
    C = () => {
      if (!(n != null && n.withdrawalSummary) || !Array.isArray(n.withdrawalSummary))
        return (
          console.log(
            "Withdrawal data not available or invalid:",
            n == null ? undefined : n.withdrawalSummary,
          ),
          []
        );
      const R = n.withdrawalSummary
        .filter((W) => W && W.status && (W.total_amount || W.total_amount === 0))
        .map((W) => ({
          ...W,
          name: W.status.charAt(0).toUpperCase() + W.status.slice(1),
          value: parseFloat(W.total_amount || 0),
        }));
      return (console.log("Prepared withdrawal data:", R), R);
    },
    A = (R) => {
      g(R);
    },
    T = () => {
      p > 1 && g(p - 1);
    },
    M = () => {
      const R = _();
      p < R && g(p + 1);
    },
    k = (R) => {
      (h(R), g(1));
    },
    $ = ["#4f46e5", "#8b5cf6", "#ec4899", "#f59e0b", "#10b981", "#3b82f6", "#ef4444"],
    I = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    };
  if (a && !e && !n)
    return (
      <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
          <div className={"flex items-center justify-center h-screen"}>
          <div className={"p-8 flex flex-col items-center"}>
            <div className={"w-16 h-16 relative"}>
              <div
                className={
                  "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
                }
              />
              <div
                className={
                  "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-700 animate-pulse opacity-75"
                }
              />
            </div>
            <p className={"mt-4 text-gray-600"}>{"Loading analytics data..."}</p>
          </div>
        </div>
      </div>
    );
  const U = b(),
    q = S(),
    z = C();
  return (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <main className="admin-main">
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={I}
          className={"mb-8 flex flex-col md:flex-row justify-between items-start md:items-center"}
        >
          <div>
            <h1 className={"text-3xl font-bold text-gray-900 mb-2"}>{"Analytics & Reports"}</h1>
            <p className={"text-gray-600"}>
              {"Comprehensive analytics about your platform's performance"}
            </p>
          </div>
          <div className={"mt-4 md:mt-0"}>
            <button
              onClick={j}
              className={
                "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
              }
            >
              <RefreshCwIcon className={"h-5 w-5 mr-2"} />
              {"Refresh Data"}
            </button>
          </div>
        </motion.div>
        {c && (
          <motion.div initial={"hidden"} animate={"visible"} variants={I} className={"mb-6"}>
            <div
              className={"bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md"}
              role={"alert"}
            >
              <p className={"font-medium"}>{"Error"}</p>
              <p>{c}</p>
            </div>
          </motion.div>
        )}
        <motion.div initial={"hidden"} animate={"visible"} variants={I} className={"mb-6"}>
          <div className={"flex border-b border-gray-200"}>
            <button
              className={`pb-4 px-6 font-medium text-sm focus:outline-none ${f === "overview" ? "border-b-2 border-purple-600 text-purple-600" : "text-gray-500 hover:text-gray-700"}`}
              onClick={() => k("overview")}
            >
              {"Overview"}
            </button>
            <button
              className={`pb-4 px-6 font-medium text-sm focus:outline-none ${f === "products" ? "border-b-2 border-purple-600 text-purple-600" : "text-gray-500 hover:text-gray-700"}`}
              onClick={() => k("products")}
            >
              {"Products"}
            </button>
            <button
              className={`pb-4 px-6 font-medium text-sm focus:outline-none ${f === "financial" ? "border-b-2 border-purple-600 text-purple-600" : "text-gray-500 hover:text-gray-700"}`}
              onClick={() => k("financial")}
            >
              {"Financial"}
            </button>
          </div>
        </motion.div>
        {f === "overview" && (
          <motion.div initial={"hidden"} animate={"visible"} variants={I}>
            <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"}>
              <div className={"bg-white rounded-xl shadow-md p-6"}>
                <div className={"flex items-center mb-4"}>
                  <div
                    className={
                      "w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center text-purple-600 mr-4"
                    }
                  >
                    <PackageIcon className={"h-6 w-6"} />
                  </div>
                  <div>
                    <p className={"text-sm text-gray-500"}>{"Total Products"}</p>
                    <h3 className={"text-2xl font-bold text-gray-800"}>
                      {(e?.categoryCounts?.[0]?.count) || 0}
                    </h3>
                  </div>
                </div>
                <button
                  onClick={() => v("/admin/products")}
                  className={
                    "text-purple-600 text-sm font-medium hover:text-purple-800 transition-colors flex items-center"
                  }
                >
                  {"View Products"}
                </button>
              </div>
              <div className={"bg-white rounded-xl shadow-md p-6"}>
                <div className={"flex items-center mb-4"}>
                  <div
                    className={
                      "w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center text-green-600 mr-4"
                    }
                  >
                    <DollarSignIcon className={"h-6 w-6"} />
                  </div>
                  <div>
                    <p className={"text-sm text-gray-500"}>{"Total Revenue"}</p>
                    <h3 className={"text-2xl font-bold text-gray-800"}>
                      {N(n == null ? undefined : n.totalRevenue)}
                    </h3>
                  </div>
                </div>
                <button
                  onClick={() => h("financial")}
                  className={
                    "text-green-600 text-sm font-medium hover:text-green-800 transition-colors flex items-center"
                  }
                >
                  {"Financial Details"}
                </button>
              </div>
              <div className={"bg-white rounded-xl shadow-md p-6"}>
                <div className={"flex items-center mb-4"}>
                  <div
                    className={
                      "w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center text-amber-600 mr-4"
                    }
                  >
                    <TrendingUpIcon className={"h-6 w-6"} />
                  </div>
                  <div>
                    <p className={"text-sm text-gray-500"}>{"Agent Commissions"}</p>
                    <h3 className={"text-2xl font-bold text-gray-800"}>
                      {N(
                        (Y = n == null ? undefined : n.agentCommissions) == null
                          ? undefined
                          : Y.reduce((R, W) => R + parseFloat(W.total_commission || 0), 0),
                      )}
                    </h3>
                  </div>
                </div>
                <button
                  onClick={() => v("/admin/agents")}
                  className={
                    "text-amber-600 text-sm font-medium hover:text-amber-800 transition-colors flex items-center"
                  }
                >
                  {"View Agents"}
                </button>
              </div>
              <div className={"bg-white rounded-xl shadow-md p-6"}>
                <div className={"flex items-center mb-4"}>
                  <div
                    className={
                      "w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center text-red-600 mr-4"
                    }
                  >
                    <DownloadIcon className={"h-6 w-6"} />
                  </div>
                  <div>
                    <p className={"text-sm text-gray-500"}>{"Pending Withdrawals"}</p>
                    <h3 className={"text-2xl font-bold text-gray-800"}>
                      {N(
                        ((B =
                          (F = n == null ? undefined : n.withdrawalSummary) == null
                            ? undefined
                            : F.find((R) => R.status === "pending")) == null
                          ? undefined
                          : B.total_amount) || 0,
                      )}
                    </h3>
                  </div>
                </div>
                <button
                  onClick={() => v("/admin/withdrawals")}
                  className={
                    "text-red-600 text-sm font-medium hover:text-red-800 transition-colors flex items-center"
                  }
                >
                  {"Process Withdrawals"}
                </button>
              </div>
            </div>
            <div className={"bg-white rounded-xl shadow-md p-6 mb-8"}>
              <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>{"Revenue Over Time"}</h3>
              <div className={"h-80"}>
                <ResponsiveContainer width={"100%"} height={"100%"}>
                  <LineChart
                    data={(n == null ? undefined : n.monthlyRevenue) || []}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray={"3 3"} />
                    <XAxis
                      dataKey={"month"}
                      tickFormatter={(R) =>
                        new Date(R).toLocaleDateString("en-US", {
                          month: "short",
                          year: "2-digit",
                        })
                      }
                    />
                    <YAxis tickFormatter={(R) => `₹${R}`} />
                    <Tooltip
                      formatter={(R) => [`₹${parseFloat(R).toFixed(2)}`, "Revenue"]}
                      labelFormatter={(R) =>
                        new Date(R).toLocaleDateString("en-US", {
                          month: "long",
                          year: "numeric",
                        })
                      }
                    />
                    <Legend />
                    {
                      <Line
                        type={"monotone"}
                        dataKey={"revenue"}
                        stroke={"#4f46e5"}
                        strokeWidth={3}
                        activeDot={{
                          r: 8,
                        }}
                      />
                    }
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className={"grid grid-cols-1 md:grid-cols-2 gap-6 mb-8"}>
              <div className={"bg-white rounded-xl shadow-md p-6"}>
                <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>
                  {"Products by Category"}
                </h3>
                <div className={"h-64"}>
                  {U.length > 0 ? (
                    <ResponsiveContainer width={"100%"} height={"100%"}>
                      {
                        <PieChart>
                          <Pie
                            data={U}
                            cx={"50%"}
                            cy={"50%"}
                            labelLine={false}
                            label={({ category: R, percent: W }) =>
                              `${R}: ${(W * 100).toFixed(0)}%`
                            }
                            outerRadius={80}
                            fill={"#8884d8"}
                            dataKey={"count"}
                          >
                            {U.map((R, W) => (
                              <Cell key={`cell-${W}`} fill={$[W % $.length]} />
                            ))}
                          </Pie>
                          <Tooltip formatter={(R, W, xe) => [R, xe.payload.category]} />
                          <Legend />
                        </PieChart>
                      }
                    </ResponsiveContainer>
                  ) : (
                    <div className={"flex items-center justify-center h-full"}>
                      <p className={"text-gray-500"}>{"No category data available"}</p>
                    </div>
                  )}
                </div>
              </div>
              <div className={"bg-white rounded-xl shadow-md p-6"}>
                <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>
                  {"Products by Analysis Status"}
                </h3>
                <div className={"h-64"}>
                  {q.length > 0 ? (
                    <ResponsiveContainer width={"100%"} height={"100%"}>
                      {
                        <PieChart>
                          <Pie
                            data={q}
                            cx={"50%"}
                            cy={"50%"}
                            labelLine={false}
                            label={({ name: R, percent: W }) => `${R}: ${(W * 100).toFixed(0)}%`}
                            outerRadius={80}
                            fill={"#8884d8"}
                            dataKey={"count"}
                          >
                            {q.map((R, W) => (
                              <Cell
                                key={`cell-${W}`}
                                fill={
                                  R.status === "completed"
                                    ? "#10b981"
                                    : R.status === "pending"
                                      ? "#f59e0b"
                                      : R.status === "failed"
                                        ? "#ef4444"
                                        : "#6b7280"
                                }
                              />
                            ))}
                          </Pie>
                          <Tooltip formatter={(R, W, xe) => [R, xe.payload.status]} />
                          <Legend formatter={(R, W) => W.payload.status} />
                        </PieChart>
                      }
                    </ResponsiveContainer>
                  ) : (
                    <div className={"flex items-center justify-center h-full"}>
                      <p className={"text-gray-500"}>{"No analysis status data available"}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={"bg-white rounded-xl shadow-md p-6"}>
              <div className={"flex justify-between items-center mb-4"}>
                <h3 className={"text-lg font-semibold text-gray-800"}>{"Top Selling Products"}</h3>
                {((K = e == null ? undefined : e.topProducts) == null ? undefined : K.length) >
                  y && (
                  <div className={"text-sm text-gray-500"}>
                    {"Showing "}
                    {(p - 1) * y + 1}
                    {" to "}
                    {Math.min(p * y, e.topProducts.length)}
                    {" of "}
                    {e.topProducts.length}
                    {" products"}
                  </div>
                )}
              </div>
              {O().length > 0 ? (
                <jsxRuntime.Fragment>
                  <div className={"overflow-x-auto"}>
                    <table className={"min-w-full divide-y divide-gray-200"}>
                      <thead className={"bg-gray-50"}>
                        <tr>
                          <th
                            scope={"col"}
                            className={
                              "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Rank"}
                          </th>
                          <th
                            scope={"col"}
                            className={
                              "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Product Name"}
                          </th>
                          <th
                            scope={"col"}
                            className={
                              "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Category"}
                          </th>
                          <th
                            scope={"col"}
                            className={
                              "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Sales Count"}
                          </th>
                          <th
                            scope={"col"}
                            className={
                              "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }
                          >
                            {"Revenue"}
                          </th>
                        </tr>
                      </thead>
                      <tbody className={"bg-white divide-y divide-gray-200"}>
                        {O().map((R, W) => {
                          const xe = (p - 1) * y + W + 1;
                          return (
                            <tr key={R.id || W} className={"hover:bg-gray-50 transition-colors"}>
                              <td className={"px-6 py-4 whitespace-nowrap text-sm text-gray-500"}>
                                <div className={"flex items-center"}>
                                  <span
                                    className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold ${xe <= 3 ? (xe === 1 ? "bg-yellow-100 text-yellow-800" : xe === 2 ? "bg-gray-100 text-gray-800" : "bg-orange-100 text-orange-800") : "bg-purple-200 text-purple-900"}`}
                                  >
                                    {xe}
                                  </span>
                                  {xe <= 3 && <span className={"ml-2 text-lg"}>{""}</span>}
                                </div>
                              </td>
                              <td className={"px-6 py-4 whitespace-nowrap"}>
                                <div className={"flex items-center"}>
                                  <div className={"flex-shrink-0 h-10 w-10"}>
                                    <div
                                      className={
                                        "h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center"
                                      }
                                    >
                                      <PackageIcon className={"h-5 w-5 text-purple-600"} />
                                    </div>
                                  </div>
                                  <div className={"ml-4"}>
                                    <div
                                      className={
                                        "text-sm font-medium text-gray-900 max-w-xs truncate"
                                      }
                                      title={R.title}
                                    >
                                      {R.title}
                                    </div>
                                    {R.description && (
                                      <div
                                        className={"text-sm text-gray-500 max-w-xs truncate"}
                                        title={R.description}
                                      >
                                        {R.description}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td className={"px-6 py-4 whitespace-nowrap"}>
                                <span
                                  className={
                                    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800"
                                  }
                                >
                                  {R.category || "Uncategorized"}
                                </span>
                              </td>
                              <td className={"px-6 py-4 whitespace-nowrap text-sm text-gray-900"}>
                                <div className={"flex items-center"}>
                                  <CircleCheckBigIcon className={"h-4 w-4 text-green-500 mr-2"} />
                                  <span className={"font-medium"}>{R.sales_count || 0}</span>
                                  <span className={"text-gray-500 ml-1"}>{"sales"}</span>
                                </div>
                              </td>
                              <td
                                className={
                                  "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                                }
                              >
                                {N(R.revenue || 0)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {_() > 1 && (
                    <div
                      className={
                        "flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 mt-4"
                      }
                    >
                      <div className={"flex flex-1 justify-between sm:hidden"}>
                        <button
                          onClick={T}
                          disabled={p === 1}
                          className={`relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 ${p === 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                        >
                          {"Previous"}
                        </button>
                        <button
                          onClick={M}
                          disabled={p === _()}
                          className={`relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 ${p === _() ? "opacity-50 cursor-not-allowed" : ""}`}
                        >
                          {"Next"}
                        </button>
                      </div>
                      <div
                        className={"hidden sm:flex sm:flex-1 sm:items-center sm:justify-between"}
                      >
                        <div>
                          <p className={"text-sm text-gray-700"}>
                            {"Showing"} <span className={"font-medium"}>{(p - 1) * y + 1}</span>{" "}
                            {"to"}{" "}
                            <span className={"font-medium"}>
                              {Math.min(
                                p * y,
                                ((Q = e == null ? undefined : e.topProducts) == null
                                  ? undefined
                                  : Q.length) || 0,
                              )}
                            </span>{" "}
                            {"of"}{" "}
                            <span className={"font-medium"}>
                              {((ne = e == null ? undefined : e.topProducts) == null
                                ? undefined
                                : ne.length) || 0}
                            </span>{" "}
                            {"results"}
                          </p>
                        </div>
                        <div>
                          <nav
                            className={"isolate inline-flex -space-x-px rounded-md shadow-sm"}
                            aria-label={"Pagination"}
                          >
                            <button
                              onClick={T}
                              disabled={p === 1}
                              className={`relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${p === 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                            >
                              <span className={"sr-only"}>{"Previous"}</span>
                              <svg
                                className={"h-5 w-5"}
                                viewBox={"0 0 20 20"}
                                fill={"currentColor"}
                                aria-hidden={"true"}
                              >
                                <path
                                  fillRule={"evenodd"}
                                  d={
                                    "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                                  }
                                  clipRule={"evenodd"}
                                />
                              </svg>
                            </button>
                            {Array.from(
                              {
                                length: _(),
                              },
                              (R, W) => W + 1,
                            ).map((R) => {
                              const W = R === 1 || R === _() || Math.abs(R - p) <= 1;
                              return !W && R === 2 && p > 4 ? (
                                <span
                                  key={"dots1"}
                                  className={
                                    "relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300"
                                  }
                                >
                                  {"..."}
                                </span>
                              ) : !W && R === _() - 1 && p < _() - 3 ? (
                                <span
                                  key={"dots2"}
                                  className={
                                    "relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300"
                                  }
                                >
                                  {"..."}
                                </span>
                              ) : W ? (
                                <button
                                  key={R}
                                  onClick={() => A(R)}
                                  className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${p === R ? "z-10 bg-purple-600 text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600" : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"}`}
                                >
                                  {R}
                                </button>
                              ) : null;
                            })}
                            <button
                              onClick={M}
                              disabled={p === _()}
                              className={`relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${p === _() ? "opacity-50 cursor-not-allowed" : ""}`}
                            >
                              <span className={"sr-only"}>{"Next"}</span>
                              <svg
                                className={"h-5 w-5"}
                                viewBox={"0 0 20 20"}
                                fill={"currentColor"}
                                aria-hidden={"true"}
                              >
                                <path
                                  fillRule={"evenodd"}
                                  d={
                                    "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                  }
                                  clipRule={"evenodd"}
                                />
                              </svg>
                            </button>
                          </nav>
                        </div>
                      </div>
                    </div>
                  )}
                </jsxRuntime.Fragment>
              ) : (
                <div className={"text-center p-6"}>
                  <p className={"text-gray-500"}>{"No sales data available yet."}</p>
                </div>
              )}
            </div>
          </motion.div>
        )}
        {f === "products" && (
          <motion.div initial={"hidden"} animate={"visible"} variants={I}>
            <div className={"bg-white rounded-xl shadow-md p-6 mb-8"}>
              <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>
                {"Products by Category"}
              </h3>
              <div className={"h-80"}>
                {U.length > 0 ? (
                  <ResponsiveContainer width={"100%"} height={"100%"}>
                    {
                      <BarChart
                        data={U}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray={"3 3"} />
                        <XAxis dataKey={"category"} />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey={"count"} name={"Number of Products"} fill={"#4f46e5"} />
                      </BarChart>
                    }
                  </ResponsiveContainer>
                ) : (
                  <div className={"flex items-center justify-center h-full"}>
                    <p className={"text-gray-500"}>{"No category data available"}</p>
                  </div>
                )}
              </div>
            </div>
            <div className={"bg-white rounded-xl shadow-md p-6 mb-8"}>
              <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>
                {"Products by Analysis Status"}
              </h3>
              <div className={"h-80"}>
                {q.length > 0 ? (
                  <ResponsiveContainer width={"100%"} height={"100%"}>
                    {
                      <BarChart
                        data={q}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray={"3 3"} />
                        <XAxis dataKey={"status"} />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey={"count"} name={"Number of Products"}>
                          {q.map((R, W) => (
                            <Cell
                              key={`cell-${W}`}
                              fill={
                                R.status === "completed"
                                  ? "#10b981"
                                  : R.status === "pending"
                                    ? "#f59e0b"
                                    : R.status === "failed"
                                      ? "#ef4444"
                                      : "#6b7280"
                              }
                            />
                          ))}
                        </Bar>
                      </BarChart>
                    }
                  </ResponsiveContainer>
                ) : (
                  <div className={"flex items-center justify-center h-full"}>
                    <p className={"text-gray-500"}>{"No analysis status data available"}</p>
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        )}
        {f === "financial" && (
          <motion.div initial={"hidden"} animate={"visible"} variants={I}>
            <div className={"grid grid-cols-1 md:grid-cols-3 gap-6 mb-8"}>
              <div className={"bg-white rounded-xl shadow-md p-6"}>
                <div className={"flex items-center mb-4"}>
                  <div
                    className={
                      "w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center text-green-600 mr-4"
                    }
                  >
                    <DollarSignIcon className={"h-6 w-6"} />
                  </div>
                  <div>
                    <p className={"text-sm text-gray-500"}>{"Total Revenue"}</p>
                    <h3 className={"text-2xl font-bold text-gray-800"}>
                      {N(n == null ? undefined : n.totalRevenue)}
                    </h3>
                  </div>
                </div>
              </div>
              <div className={"bg-white rounded-xl shadow-md p-6"}>
                <div className={"flex items-center mb-4"}>
                  <div
                    className={
                      "w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center text-amber-600 mr-4"
                    }
                  >
                    <TrendingUpIcon className={"h-6 w-6"} />
                  </div>
                  <div>
                    <p className={"text-sm text-gray-500"}>{"Total Commissions"}</p>
                    <h3 className={"text-2xl font-bold text-gray-800"}>
                      {N(
                        (L = n == null ? undefined : n.agentCommissions) == null
                          ? undefined
                          : L.reduce((R, W) => R + parseFloat(W.total_commission || 0), 0),
                      )}
                    </h3>
                  </div>
                </div>
              </div>
              <div className={"bg-white rounded-xl shadow-md p-6"}>
                <div className={"flex items-center mb-4"}>
                  <div
                    className={
                      "w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center text-red-600 mr-4"
                    }
                  >
                    <DownloadIcon className={"h-6 w-6"} />
                  </div>
                  <div>
                    <p className={"text-sm text-gray-500"}>{"Total Withdrawals"}</p>
                    <h3 className={"text-2xl font-bold text-gray-800"}>
                      {N(
                        (ee = n == null ? undefined : n.withdrawalSummary) == null
                          ? undefined
                          : ee.reduce((R, W) => R + parseFloat(W.total_amount || 0), 0),
                      )}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className={"bg-white rounded-xl shadow-md p-6 mb-8"}>
              <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>{"Monthly Revenue"}</h3>
              <div className={"h-80"}>
                <ResponsiveContainer width={"100%"} height={"100%"}>
                  <LineChart
                    data={(n == null ? undefined : n.monthlyRevenue) || []}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray={"3 3"} />
                    <XAxis
                      dataKey={"month"}
                      tickFormatter={(R) =>
                        new Date(R).toLocaleDateString("en-US", {
                          month: "short",
                          year: "2-digit",
                        })
                      }
                    />
                    <YAxis tickFormatter={(R) => `₹${R}`} />
                    <Tooltip
                      formatter={(R) => [`₹${parseFloat(R).toFixed(2)}`, "Revenue"]}
                      labelFormatter={(R) =>
                        new Date(R).toLocaleDateString("en-US", {
                          month: "long",
                          year: "numeric",
                        })
                      }
                    />
                    <Legend />
                    {
                      <Line
                        type={"monotone"}
                        dataKey={"revenue"}
                        stroke={"#10b981"}
                        strokeWidth={3}
                        activeDot={{
                          r: 8,
                        }}
                      />
                    }
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className={"bg-white rounded-xl shadow-md p-6 mb-8"}>
              <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>{"Agent Commissions"}</h3>
              {((re = n == null ? undefined : n.agentCommissions) == null ? undefined : re.length) >
              0 ? (
                <div className={"h-80"}>
                  <ResponsiveContainer width={"100%"} height={"100%"}>
                    {
                      <BarChart
                        data={n.agentCommissions}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray={"3 3"} />
                        <XAxis dataKey={"agent_name"} />
                        <YAxis tickFormatter={(R) => `₹${R}`} />
                        <Tooltip
                          formatter={(R) => [`₹${parseFloat(R).toFixed(2)}`, "Commission"]}
                        />
                        <Legend />
                        <Bar
                          dataKey={"total_commission"}
                          name={"Total Commission"}
                          fill={"#f59e0b"}
                        />
                      </BarChart>
                    }
                  </ResponsiveContainer>
                </div>
              ) : (
                <div className={"text-center p-6"}>
                  <p className={"text-gray-500"}>{"No commission data available yet."}</p>
                </div>
              )}
            </div>
            <div className={"bg-white rounded-xl shadow-md p-6"}>
              <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>{"Withdrawal Status"}</h3>
              {z.length > 0 ? (
                <div className={"grid grid-cols-1 lg:grid-cols-2 gap-6"}>
                  <div className={"h-80"}>
                    <ResponsiveContainer width={"100%"} height={"100%"}>
                      {
                        <PieChart>
                          <Pie
                            data={z}
                            cx={"50%"}
                            cy={"50%"}
                            labelLine={false}
                            label={({ name: R, percent: W }) => `${R}: ${(W * 100).toFixed(0)}%`}
                            outerRadius={80}
                            fill={"#8884d8"}
                            dataKey={"value"}
                          >
                            {z.map((R, W) => (
                              <Cell
                                key={`cell-${W}`}
                                fill={
                                  R.status === "completed"
                                    ? "#10b981"
                                    : R.status === "pending"
                                      ? "#f59e0b"
                                      : R.status === "failed"
                                        ? "#ef4444"
                                        : "#6b7280"
                                }
                              />
                            ))}
                          </Pie>
                          <Tooltip formatter={(R) => [`₹${parseFloat(R).toFixed(2)}`, "Amount"]} />
                          <Legend />
                        </PieChart>
                      }
                    </ResponsiveContainer>
                  </div>
                  <div className={"space-y-4"}>
                    {z.map((R, W) => (
                      <div
                        key={W}
                        className={"border rounded-lg p-4 hover:shadow-md transition-shadow"}
                      >
                        <div className={"flex items-center justify-between"}>
                          <div className={"flex items-center"}>
                            <div
                              className={"w-4 h-4 rounded-full mr-3"}
                              style={{
                                backgroundColor:
                                  R.status === "completed"
                                    ? "#10b981"
                                    : R.status === "pending"
                                      ? "#f59e0b"
                                      : R.status === "failed"
                                        ? "#ef4444"
                                        : "#6b7280",
                              }}
                            />
                            <div>
                              <h4 className={"font-medium text-gray-900 capitalize"}>
                                {R.status}
                                {" Withdrawals"}
                              </h4>
                              <p className={"text-sm text-gray-500"}>{"Total amount withdrawn"}</p>
                            </div>
                          </div>
                          <div className={"text-right"}>
                            <p className={"text-lg font-semibold text-gray-900"}>{N(R.value)}</p>
                            {(n == null ? undefined : n.withdrawalSummary) && (
                              <p className={"text-sm text-gray-500"}>
                                {((R.value / z.reduce((xe, ve) => xe + ve.value, 0)) * 100).toFixed(
                                  1,
                                )}
                                {"%"}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className={"border-t pt-4 mt-4"}>
                      <div className={"flex justify-between items-center"}>
                        <span className={"font-medium text-gray-900"}>{"Total Withdrawals"}</span>
                        <span className={"text-xl font-bold text-gray-900"}>
                          {N(z.reduce((R, W) => R + W.value, 0))}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={"text-center p-12"}>
                  <div
                    className={
                      "w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center"
                    }
                  >
                    <DownloadIcon className={"h-8 w-8 text-gray-400"} />
                  </div>
                  <h4 className={"text-lg font-medium text-gray-900 mb-2"}>
                    {"No Withdrawal Data"}
                  </h4>
                  <p className={"text-gray-500"}>
                    {"No withdrawal transactions have been recorded yet."}
                  </p>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </main>
    </div>
  );
};
export { AnalyticsPage };
